export type GalleryCategory = "walls" | "floors";

export type GalleryItem = {
  src: string;
  width: number;
  height: number;
  alt: string;
  caption: string;
  category: GalleryCategory;
  variants: readonly { src: string; width: number }[];
};

function variantsFor(base: string): readonly { src: string; width: number }[] {
  const stem = base.replace(/\.jpeg$/, "");
  return [
    { src: `${stem}-480.webp`, width: 480 },
    { src: `${stem}-768.webp`, width: 768 },
    { src: `${stem}-1200.webp`, width: 1200 },
  ];
}

// Single source for PlasteringGallery. Variants are WebP at 480/768/1200 (q78)
// generated by scripts/generate-responsive-images.ts from the JPEG originals.
export const galleryItems: readonly GalleryItem[] = [
  {
    src: "/media/photos/plastering/plastering_1.jpeg",
    width: 800,
    height: 1067,
    alt: "Свежая штукатурка на длинной стене",
    caption: "Ровная стена с мягким сиянием от свежего слоя штукатурки.",
    category: "walls",
    variants: variantsFor("/media/photos/plastering/plastering_1.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_2.jpeg",
    width: 800,
    height: 1067,
    alt: "Штукатуренный столб с электрикой",
    caption: "Колонна идеально выведена под разводку электрики.",
    category: "walls",
    variants: variantsFor("/media/photos/plastering/plastering_2.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_3.jpeg",
    width: 800,
    height: 1067,
    alt: "Длинная штукатуренная стена",
    caption: "Протяжённая поверхность выдержана в одной плоскости.",
    category: "walls",
    variants: variantsFor("/media/photos/plastering/plastering_3.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_4.jpeg",
    width: 800,
    height: 1067,
    alt: "Коридор со свежей штукатуркой",
    caption: "Аккуратные проёмы и чистые линии в коридоре.",
    category: "walls",
    variants: variantsFor("/media/photos/plastering/plastering_4.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_5.jpeg",
    width: 800,
    height: 1067,
    alt: "Крупный план штукатуренного угла",
    caption: "Чёткий угол демонстрирует контроль над ребром.",
    category: "walls",
    variants: variantsFor("/media/photos/plastering/plastering_5.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_6.jpeg",
    width: 800,
    height: 1067,
    alt: "Крупный план свежей стяжки",
    caption: "Текстура свежей стяжки под контролем уровня.",
    category: "floors",
    variants: variantsFor("/media/photos/plastering/plastering_6.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_7.jpeg",
    width: 800,
    height: 1067,
    alt: "Пустая комната с гладкой стяжкой",
    caption: "Ровная плоскость пола готова к финальному покрытию.",
    category: "floors",
    variants: variantsFor("/media/photos/plastering/plastering_7.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_8.jpeg",
    width: 800,
    height: 1067,
    alt: "Просторное помещение со стяжкой",
    caption: "Механизированная затирка выравнивает площадь большого помещения.",
    category: "floors",
    variants: variantsFor("/media/photos/plastering/plastering_8.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_9.jpeg",
    width: 800,
    height: 1067,
    alt: "Длинный коридор со свежей стяжкой",
    caption: "Длинная ось с идеальной отметкой уровня.",
    category: "floors",
    variants: variantsFor("/media/photos/plastering/plastering_9.jpeg"),
  },
  {
    src: "/media/photos/plastering/plastering_10.jpeg",
    width: 800,
    height: 1067,
    alt: "Стык стяжки с белой стеной",
    caption: "Идеальный стык пола и стены без перепадов.",
    category: "floors",
    variants: variantsFor("/media/photos/plastering/plastering_10.jpeg"),
  },
] as const;
